<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <!-- <p class="imgItem1">ข้อตกลงความเป็นส่วนตัว</p> -->
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="pricacy img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <!-- <div class="textBox" style="white-space: pre-wrap">{{ text }}</div> -->
        <h2 class="topTit">ประกาศนโยบายความเป็นส่วนตัว (Privacy Notice)</h2>
        <h2 class="oneTit">PHAYAOPICO COMPANY LIMITED</h2>
        <p>
          PHAYAOPICO COMPANY LIMITED ผู้พัฒนาและให้บริการแอปพลิเคชัน เงินโตเร็ว
          ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้งานอย่างสูงสุด
          โดยปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)
          และข้อกำหนดที่เกี่ยวข้อง
        </p>
        <p>
          นโยบายฉบับนี้ใช้กับข้อมูลส่วนบุคคลทั้งหมดที่บริษัทฯ
          ได้รับจากท่านผ่านการใช้งานแอปพลิเคชัน เว็บไซต์ ช่องทางบริการลูกค้า
          หรือการติดต่อสื่อสารอื่นใด บริษัทฯ ซึ่งมีที่อยู่ที่ 137/3
          ถนนหัวขวางแก้ว อำเภอเมืองพะเยา จังหวัดพะเยา 56000
          จะเป็นผู้ควบคุมข้อมูลส่วนบุคคลในการดำเนินการต่าง ๆ ที่เกี่ยวข้อง
        </p>
        <h4 class="twoTit">
          1.การเก็บรวบรวมและวัตถุประสงค์ในการใช้ข้อมูลส่วนบุคคล
        </h4>
        <p>
          บริษัทฯ
          อาจเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของท่านโดยมีวัตถุประสงค์อันชอบด้วยกฎหมาย
          ดังต่อไปนี้:
        </p>

        <p>เพื่อให้บริการด้านสินเชื่อและประเมินความเสี่ยงด้านเครดิต</p>
        <p>เพื่อดำเนินการตามสัญญาและให้บริการสนับสนุนลูกค้า</p>

        <p>
          เพื่อปฏิบัติตามกฎหมายว่าด้วยการต่อต้านการฟอกเงิน (AML)
          และการต่อต้านการสนับสนุนทางการเงินแก่การก่อการร้าย (CFT)
        </p>
        <p>เพื่อป้องกันการฉ้อโกงหรือกิจกรรมที่ผิดกฎหมาย</p>
        <p>เพื่อปฏิบัติตามข้อกำหนดของกฎหมายหรือหน่วยงานกำกับดูแล</p>
        <p>เพื่อพัฒนาบริการและประสบการณ์ของผู้ใช้งานให้ดียิ่งขึ้น</p>
        <p>
          บริษัทฯ อาจเก็บข้อมูลส่วนบุคคลของท่านโดยตรงจากตัวท่าน ผู้รับมอบอำนาจ
          พนักงาน หรือที่ปรึกษา ตลอดจนผ่านทางเทคโนโลยี เช่น แอปพลิเคชัน เว็บไซต์
          หรืออุปกรณ์เคลื่อนที่
        </p>
        <h4 class="twoTit">
          2.ประเภทของข้อมูลส่วนบุคคลที่บริษัทฯ อาจเก็บรวบรวม
        </h4>
        <p>เพื่อวัตถุประสงค์ข้างต้น บริษัทฯ อาจเก็บรวบรวมข้อมูลต่อไปนี้:</p>
        <p>ข้อมูลการติดต่อ: หมายเลขโทรศัพท์ อีเมล ที่อยู่</p>
        <p>
          ข้อมูลประจำตัว: ชื่อ-นามสกุล วันเดือนปีเกิด เลขบัตรประจำตัวประชาชน
          รูปถ่าย เพศ
        </p>
        <p>
          ข้อมูลชีวมิติ: เช่น การสแกนใบหน้า (ในกรณีที่เปิดใช้งานฟีเจอร์ดังกล่าว)
          ข้อมูลอุปกรณ์: IMEI, IP address, MAC address, รุ่นอุปกรณ์,
          ระบบปฏิบัติการ, เครือข่ายโทรศัพท์
        </p>
        <p>ข้อมูลตำแหน่ง: พิกัดโดยประมาณ</p>
        <p>
          ข้อมูลทางการเงิน: รายได้, ข้อมูลบัญชีธนาคาร, ข้อมูลการทำงาน,
          วัตถุประสงค์ในการขอสินเชื่อ, ระดับการศึกษา
        </p>
        <p>
          ข้อมูลการสื่อสาร: ข้อความ SMS (ใช้เฉพาะเพื่อการประเมินเครดิตตามกฎหมาย)
          รายชื่อผู้ติดต่อ
        </p>
        <p>
          ข้อมูลพฤติกรรมการใช้งาน: การติดตั้งแอป, ความถี่ในการใช้งาน,
          หน้าจอที่เข้าชม, การกดใช้งาน
        </p>
        <p>
          บริษัทฯ จะดำเนินการเก็บรวบรวม ใช้
          และจัดการข้อมูลของท่านภายใต้กรอบกฎหมาย
          และเพื่อวัตถุประสงค์ที่ชัดเจนและชอบด้วยกฎหมายเท่านั้น
        </p>
        <el-row
          type="flex"
          class="table-row"
          justify="space-between"
          :gutter="80"
        >
          <el-col :span="12">
            <el-row
              ><p>1）การเข้าถึงข้อมูลจากอุปกรณ์</p>
              <p>
                แอปพลิเคชันอาจเก็บรวบรวมข้อมูลเกี่ยวกับอุปกรณ์ของท่าน เช่น
                ยี่ห้อและรุ่นของโทรศัพท์ ระบบปฏิบัติการ หมายเลข IMEI รหัสอุปกรณ์
                (Device ID) ที่อยู่ MAC และที่อยู่ IP
                เพื่อวัตถุประสงค์ในการตรวจสอบความปลอดภัย ป้องกันการฉ้อโกง
                และปรับปรุงประสบการณ์การใช้งานของผู้ใช้
              </p></el-row
            >
            <el-row
              ><p>3）การเข้าถึงกล้อง</p>
              <p>
                เราจะขอสิทธิ์การใช้กล้องของท่านเพื่อ ถ่ายภาพเอกสารประจำตัว เช่น
                บัตรประชาชน หรือเซลฟี่เพื่อยืนยันตัวตน (KYC) เท่านั้น
                และจะไม่ใช้กล้องเพื่อวัตถุประสงค์อื่นโดยไม่ได้รับอนุญาต
              </p></el-row
            >
            <el-row
              ><p>5）การเข้าถึงปฏิทิน</p>
              <p>
                เพื่อช่วยให้คุณจัดการแผนการชำระเงินได้อย่างมีประสิทธิภาพมากขึ้น
                แอปของเราต้องการเข้าถึงปฏิทินของคุณ
                การอนุญาตนี้ใช้เพื่อเพิ่มการแจ้งเตือนการชำระเงินเท่านั้น
                เพื่อให้มั่นใจว่าคุณจะไม่พลาดวันชำระเงินที่สำคัญใดๆ
              </p></el-row
            >
          </el-col>
          <el-col :span="12">
            <el-row
              ><p>2）การเข้าถึง SMS</p>
              <p>
                เพื่อช่วยให้เราระบุบัญชีของคุณและประเมินสถานะความเสี่ยง
                เราจำเป็นต้องเข้าถึงข้อความของคุณเพื่ออ่านการยืนยันจากธนาคารที่เกี่ยวข้องกับการกู้ยืม
                เรารวบรวมข้อมูลทางการเงินเพื่อการวิเคราะห์ความเสี่ยง
                การยืนยันตัวตน และป้องกันการฉ้อโกงหรือกิจกรรมที่ผิดกฎหมาย
                ข้อมูลของคุณจะถูกเก็บไว้ในเซิร์ฟเวอร์ที่ปลอดภัยและใช้เฉพาะเพื่อการวิเคราะห์และยืนยันเครดิตเท่านั้น
                เราใช้เทคโนโลยีการเข้ารหัสที่ทันสมัย
                ดังนั้นเราจะไม่เข้าถึงข้อมูลที่ไม่เกี่ยวข้องกับการเงินหรือแชร์กับบุคคลที่สาม
                หากคุณต้องการลบข้อมูลของคุณ กรุณาติดต่อเราผ่านทางอีเมล
              </p></el-row
            >
            <el-row>
              <p>4）การเข้าถึงตำแหน่งโดยประมาณ</p>
              <p>
                แอปอาจขอเข้าถึงตำแหน่งของท่านในระดับตำแหน่งโดยประมาณ เพื่อ
                ช่วยประเมินพื้นที่การใช้งานเบื้องต้นสำหรับวิเคราะห์ความเสี่ยง
                โดยจะไม่มีการติดตามตำแหน่งแบบเรียลไทม์หรือระบุตำแหน่งที่แน่นอนของท่าน
              </p></el-row
            >
            <el-row
              ><p>6）การเข้าถึงรายการแอปพลิเคชันที่ติดตั้ง</p>
              <p>
                แอปจะตรวจสอบ รายชื่อแอปพลิเคชันที่ติดตั้งอยู่ในอุปกรณ์ของท่าน
                เพื่อวัตถุประสงค์ในการวิเคราะห์พฤติกรรมการใช้งาน เช่น
                ความสม่ำเสมอในการใช้บริการทางการเงิน
                การดาวน์โหลดแอปที่มีความเสี่ยง
                โดยข้อมูลที่ได้จะถูกเก็บไว้เป็นความลับ
                และไม่เผยแพร่แก่บุคคลที่สาม
              </p></el-row
            >
          </el-col>
        </el-row>
        <p>
          เพื่อวัตถุประสงค์ในการประเมินความน่าเชื่อถือ ตรวจสอบตัวตน
          วิเคราะห์ความเสี่ยง และป้องกันการฉ้อโกง
          แอปพลิเคชันของเราอาจขอสิทธิ์การเข้าถึงข้อมูลบางอย่างจากอุปกรณ์ของผู้ใช้
          เช่น ข้อมูลอุปกรณ์ (Device Info), ข้อความ SMS, ประวัติการโทร,
          กล้องถ่ายรูป, ข้อมูลตำแหน่งโดยประมาณ, ปฏิทิน และรายการแอปที่ติดตั้ง
          (App List)
          การเข้าถึงเหล่านี้จะดำเนินการภายใต้กรอบของกฎหมายที่เกี่ยวข้อง
          และข้อมูลที่ได้จะถูกจัดเก็บและอัปโหลดไปยังเซิร์ฟเวอร์ของบริษัทที่อยู่ที่
          <a href="https://growmoney.phayaopicocompany.com"
            >https://growmoney.phayaopicocompany.com</a
          >
          เพื่อใช้ในการให้บริการด้านสินเชื่ออย่างเหมาะสมและปลอดภัย
        </p>
        <h4 class="twoTit">3.วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล</h4>
        <p>
          บริษัท PHAYAOPICO COMPANY LIMITED อาจเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์อันชอบด้วยกฎหมาย
          ดังต่อไปนี้:
        </p>
        <p>
          การยืนยันตัวตนและการตรวจสอบข้อมูลผู้ใช้:
          เพื่อยืนยันและตรวจสอบความถูกต้องของข้อมูล
          รวมถึงการยืนยันตัวตนโดยใช้ข้อมูลชีวมิติหรือข้อมูลตามเอกสารประจำตัว
        </p>
        <p>
          การวิเคราะห์ความเสี่ยงและการตรวจสอบเครดิต:
          เพื่อประเมินสถานะทางการเงินและความเสี่ยงในการให้สินเชื่อ
          รวมถึงการตัดสินใจในการเริ่มต้นความสัมพันธ์ทางธุรกิจกับท่าน
        </p>
        <p>
          การปฏิบัติตามสัญญา:
          เพื่อให้สามารถปฏิบัติหน้าที่ตามสัญญาหรือข้อตกลงที่ทำกับท่านได้
        </p>
        <p>
          การปฏิบัติตามหน้าที่ตามกฎหมาย: เช่น
          พระราชบัญญัติป้องกันและปราบปรามการฟอกเงิน กฎหมายด้านการเงิน
          และข้อกำหนดจากหน่วยงานกำกับดูแลของไทย
        </p>
        <p>
          การให้บริการหรือตอบกลับคำร้องขอของท่าน: สำหรับการประมวลผลคำร้อง
          การสมัครใช้บริการ หรือการติดต่อสอบถามต่างๆ
        </p>
        <p>
          การดูแลและอัปเดตข้อมูลให้เป็นปัจจุบัน:
          เพื่อให้มั่นใจว่าข้อมูลของท่านที่บริษัทเก็บรักษาไว้นั้นถูกต้องและทันสมัย
        </p>
        <h4 class="twoTit">
          4.กลไกการปฏิเสธหรือเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคล
        </h4>
        <p>
          ท่านมีสิทธิที่จะปฏิเสธหรือเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลของท่านได้ตลอดเวลา
          ทั้งนี้
          การปฏิเสธหรือเพิกถอนความยินยอมอาจมีผลต่อการให้บริการบางส่วนหรือทั้งหมด
          โดยเฉพาะกรณีที่บริษัทจำเป็นต้องใช้ข้อมูลเพื่อการให้บริการสินเชื่อ
        </p>
        <p>
          หากท่านประสงค์จะใช้สิทธิดังกล่าว กรุณาส่งคำร้องขอภายในระยะเวลา ๕ (ห้า)
          วันทำการ นับจากวันที่ได้รับแจ้งนโยบายความเป็นส่วนตัวนี้
          โดยส่งอีเมลไปยังอีเมลทางการของบริษัทที่
        </p>
        <p>
          <a href="mailto:contact@phayaopicocompany.com"
            >contact@phayaopicocompany.com</a
          >
        </p>
        <p>
          โดยระบุหัวข้ออีเมลว่า
          “ขอปฏิเสธ/เพิกถอนความยินยอมการประมวลผลข้อมูลส่วนบุคคล”
        </p>
        <p>และโปรดระบุข้อมูลต่อไปนี้เพื่อใช้ในการยืนยันตัวตน:</p>
        <p>ชื่อ-นามสกุล</p>
        <p>หมายเลขโทรศัพท์หรืออีเมลที่ลงทะเบียนไว้กับเรา</p>
        <p>ข้อมูลเพิ่มเติมเพื่อการยืนยันตัวตน (ถ้ามี)</p>
        <p>
          บริษัทจะดำเนินการตามคำขอของท่านภายในระยะเวลาที่เหมาะสมตามที่กฎหมายกำหนด
          และจะมีการแจ้งผลการดำเนินการให้ทราบ
        </p>
        <p>
          หากคุณคัดค้านการประมวลผลข้อมูลส่วนบุคคลของคุณตามแถลงการณ์ความเป็นส่วนตัวนี้
          จะไม่สามารถสร้างความสัมพันธ์ทางกฎหมายได้
          โดยข้อมูลดังกล่าวจะต้องจำเป็นต่อการให้บริการ
        </p>
        <h4 class="twoTit">5.การถ่ายโอนข้อมูลส่วนบุคคลให้แก่บุคคลภายนอก</h4>
        <p>
          เราอาจถ่ายโอนหรือเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุคคลที่สามในบางกรณี
          โดยเราจะดำเนินการภายใต้ข้อกำหนดของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562
          และจะแจ้งให้บุคคลภายนอกดังกล่าวทราบถึงข้อกำหนดในประกาศความเป็นส่วนตัวฉบับนี้
          เพื่อให้บุคคลภายนอกดำเนินการตามมาตรการที่จำเป็นในการปกป้องข้อมูลของท่าน
        </p>
        <p>ข้อมูลของท่านอาจถูกถ่ายโอนไปยัง:</p>
        <p>
          ผู้ให้บริการที่เกี่ยวข้อง เช่น บริษัทข้อมูลเครดิต (Credit Bureau)
          หรือหน่วยงานที่ให้บริการตรวจสอบความถูกต้องของข้อมูล
        </p>
        <p>
          หน่วยงานกำกับดูแลของไทยที่มีอำนาจตามกฎหมาย
          เพื่อวัตถุประสงค์ในการตรวจสอบ ยืนยันข้อมูล
          หรือปฏิบัติตามกฎหมายที่เกี่ยวข้อง
        </p>
        <p>
          หน่วยงานด้านการเงินของไทยหรือระหว่างประเทศ
          หากเป็นกรณีที่มีข้อผูกพันตามกฎหมายหรือพันธกรณีระหว่างประเทศที่ประเทศไทยเป็นภาคี
        </p>
        <p>
          หน่วยงานทางกฎหมายหรือกระบวนการยุติธรรม เมื่อมีหมายเรียก คำสั่งศาล
          หรือหนังสือร้องขออย่างเป็นทางการ
        </p>
        <p>
          เราจะดำเนินการให้บุคคลภายนอกที่ได้รับข้อมูลของท่านมีประกาศความเป็นส่วนตัวของตนเอง
          และมีมาตรการคุ้มครองข้อมูลที่เหมาะสมตามที่กฎหมายกำหนด
        </p>
        <p>
          หากต้องมีการถ่ายโอนข้อมูลเพิ่มเติมและต้องการความยินยอมจากท่าน
          เราจะขอความยินยอมจากท่านล่วงหน้า PHAYAOPICO COMPANY LIMITED
          อาจถ่ายโอนข้อมูลที่เก็บรวบรวมไปยังบริษัทที่ควบคุม PHAYAOPICO COMPANY
          LIMITED หรือบริษัทย่อยหรือสถาบันการเงินที่เกี่ยวข้อง
          รวมถึงการส่งข้อมูลให้กับหน่วยงานที่มีอำนาจตามที่กฎหมายไทยกำหนดเพื่อปฏิบัติตามภาระหน้าที่ทางกฎหมาย
          เราจะรับรองว่าผู้รับข้อมูลจะดำเนินการตามมาตรการที่เพียงพอเพื่อรักษาความปลอดภัยของข้อมูล
          และปฏิบัติตามข้อกำหนดในคำชี้แจงความเป็นส่วนตัวนี้
          เจ้าของข้อมูลยอมรับและตกลงว่า PHAYAOPICO COMPANY LIMITED
          อาจบันทึกการสื่อสารทางโทรศัพท์ระหว่างเจ้าของข้อมูลและ PHAYAOPICO
          COMPANY LIMITED ตามกฎหมาย
        </p>
        <h4 class="twoTit">
          6.การจำกัดการใช้และการเปิดเผยข้อมูลส่วนบุคคลของคุณและการใช้สิทธิของผู้ใช้
        </h4>
        <p>
          คุณมีสิทธิ์ที่จะร้องขอให้เราจำกัดการใช้และการเปิดเผยข้อมูลส่วนบุคคลของคุณ
          โดยเฉพาะอย่างยิ่งหากการใช้ข้อมูลเกินกว่าวัตถุประสงค์เดิมหรือไม่ได้รับอนุญาต
          เพื่อใช้สิทธิของผู้ใช้ดังกล่าว
          คุณสามารถติดต่อเราได้โดยการส่งอีเมลไปที่<a
            href="mailto:contact@phayaopicocompany.com"
          >
            contact@phayaopicocompany.com </a
          >โดยระบุชื่อของคุณ ข้อมูลการติดต่อ และรายละเอียดคำขอของคุณ
          เราจะตอบกลับพร้อมผลลัพธ์ภายใน 20 วันทำการหลังจากได้รับคำขอของคุณ
          และดำเนินการตามมาตรการที่เกี่ยวข้องภายใน 15
          วันทำการหลังจากได้รับการยืนยัน
          หากจำเป็นต้องขยายระยะเวลาการประมวลผลเนื่องจากสถานการณ์พิเศษ
          เราจะแจ้งให้คุณทราบเป็นลายลักษณ์อักษรและอธิบายเหตุผล
        </p>
        <p>
          PHAYAOPICO COMPANY LIMITED
          ขอสงวนสิทธิ์ในการขอข้อมูลเพิ่มเติมและ/หรือเอกสารเพื่อใช้ในการแก้ไขคำขอที่กล่าวถึง
          ในกรณีที่มีข้อยกเว้นดังต่อไปนี้ PHAYAOPICO COMPANY LIMITED
          ไม่มีภาระผูกพันในการลบข้อมูลส่วนบุคคลของท่าน (i)
          หากเกี่ยวข้องกับการทำสัญญาระหว่างทั้งสองฝ่าย
          และจำเป็นสำหรับการจัดทำและการปฏิบัติตามสัญญา; (ii)
          หากจำเป็นต้องประมวลผลตามข้อกำหนดของกฎหมาย; (iii)
          หากจำเป็นเพื่อปฏิบัติตามภาระหน้าที่ทางกฎหมายที่เจ้าของข้อมูลได้รับ
          การที่ PHAYAOPICO COMPANY LIMITED
          ให้ข้อมูลโดยตรงไปยังเจ้าของข้อมูลตามที่อยู่หรือส่งข้อมูลไปยังที่อยู่อีเมลที่เจ้าของข้อมูลได้กำหนดและลบข้อมูลดังกล่าวออกจากฐานข้อมูลจะถือว่า
          PHAYAOPICO COMPANY LIMITED ได้ปฏิบัติหน้าที่ในการเข้าถึงข้อมูลแล้ว
        </p>
        <p>
          ท่านยอมรับและเข้าใจว่า
          ท่านสามารถคัดค้านการประมวลผลข้อมูลที่ไม่จำเป็นสำหรับความสัมพันธ์ทางกฎหมายและ/หรือทางธุรกิจที่ท่านมีร่วมกับ
          PHAYAOPICO COMPANY LIMITED ได้ตลอดเวลา
          โดยท่านสามารถทำการคัดค้านผ่านขั้นตอนที่ระบุในที่นี้
          ในกระบวนการประมวลผลข้อมูลส่วนบุคคลของท่าน
          เรามุ่งหวังที่จะปกป้องท่านจากความเสียหาย การสูญหาย การเปลี่ยนแปลง
          การทำลาย และการใช้ที่ไม่ได้รับอนุญาต การเข้าถึง
          หรือการประมวลผลที่ไม่ถูกต้อง
        </p>
        <p>
          การจัดการข้อร้องเรียนและการรายงาน
          หากท่านในฐานะเจ้าของข้อมูลส่วนบุคคลเชื่อว่าผลประโยชน์ในการคุ้มครองข้อมูลส่วนบุคคลของท่านถูกละเมิด
          หรือหาก PHAYAOPICO COMPANY LIMITED
          ปฏิเสธการใช้สิทธิของท่านอย่างไม่สมเหตุสมผล
          ท่านสามารถยื่นคำร้องไปยังสำนักงานคุ้มครองข้อมูลส่วนบุคคล (Personal
          Data Protection Office) หรือหน่วยงานที่เกี่ยวข้องในประเทศไทย
          ตามข้อกฎหมายที่เกี่ยวข้อง
          เพื่อขอให้ดำเนินการตามขั้นตอนการคุ้มครองสิทธิของท่านในกรณีที่มีการละเมิดสิทธิ
        </p>

        <p>
          หากคุณมีคำถามเกี่ยวกับแถลงการณ์ความเป็นส่วนตัวนี้
          คุณสามารถติดต่อเราได้ตลอดเวลา ทางโทรศัพท์หรืออีเมล์:
        </p>
        <p>บริการลูกค้า: +66 6752792103</p>
        <p>
          อีเมล:
          <a href="mailto:contact@phayaopicocompany.com"
            >contact@phayaopicocompany.com</a
          >
        </p>
        <p>ที่อยู่: 137/3 Hua Khuang Kaew Road 56000 MUEANG PHAYAO</p>
        <p>
          เว็บไซต์อย่างเป็นทางการ:<a
            href="https://growmoney.phayaopicocompany.com"
          >
            growmoney.phayaopicocompany.com</a
          >
        </p>
        <p>
          เวลาทำการ: จันทร์-ศุกร์ 9:00-18:30 น. / เสาร์-อาทิตย์ 9:00-14:30 น.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import { Row, Col } from "element-ui";
// import importedImg1 from "@/page/wingmoneycompany/components/img/4_1.png";

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
  },
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: ``,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  /* padding-top: 40px;
  padding-bottom: 20px; */
  /* height: 3700px; */
  background-color: #ffffff;
  border-radius: 32px;
  margin: 0 auto 0;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  /* transform: scale(90%); */
  /* transform: scale(80%); */
  /* margin: -150px auto 100px; */
  /* height: 1900px; */
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  /* border: 2px solid #4D64E4; */
  border-radius: 36px;
  /* border-top: 1px solid #457b9d;
  border-bottom: 1px solid #457b9d; */
  padding: 100px;
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4d64e4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  /* height: 291px; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}

.topTit,
.oneTit {
  font-size: 40px;
  line-height: 80px;
  font-weight: bold;
  font-family: finnix-bold;
  color: #406bf4;
}

.topTit {
  font-size: 48px;
  line-height: 100px;
}

.twoTit {
  font-size: 24px;
  line-height: 60px;
  font-weight: 600;
  font-family: finnix-bold;
}

.imgBox2 p {
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
  font-family: finnix-regular;
  color: #333333;
  margin-bottom: 1rem;
}

.table-bordered {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 80px;
  margin-top: 40px;
}

.table-bordered td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  padding: 26px 52px;
}

.table-bordered tr td:first-child {
  width: 300px;
  padding: 18px 43px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.pricacy a {
  color: rgb(108, 142, 235);
}

.table-row {
  width: 100%;
  margin-top: 40px;
}

.table-row .el-row {
  background-color: rgba(220, 219, 206, 0.477);
  padding: 80px;
  height: 552px;
  margin-bottom: 60px;
}
</style>
